import { FC } from "react";
import { IconProps } from "./types";
import { useThemeStore } from "../../stores";

const SendIcon: FC<IconProps> = ({
  className = "",
  color,
  height = 16,
  width = 16,
}) => {
  const theme = useThemeStore((s) => s.theme);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={color || theme.icon}
      className={className}
      viewBox="0 0 16 16"
      style={{ transform: "rotate(-90deg)" }}
    >
      <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
    </svg>
  );
};

export default SendIcon;
